export const NOTE_LIST_HEADER_HEIGHT = 50;

export const GROUP_BY_DAY = {
  today: 'Today',
  yesterday: 'Yesterday',
  older: 'Older',
};
